export default "__VITE_ASSET__247f906b__"